import store from "app/redux/store/store";
import { IOrcamento } from "app/types/IOrcamento";

export function obterOrcamentoAtual() : IOrcamento {
    return store.getState().orcamento
}